/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
//     SourceSHA: 
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { TellerOnlineApiClientBase } from 'libraries/core/src/lib/api/apiClientBase';
import { TellerOnlineWindowService } from 'libraries/shared/src/lib/services/window.service';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class SiteMetadataApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return SiteMetadataApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) SiteMetadataApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api";
    }

    static init(baseUrl: string){
        SiteMetadataApiClient._baseUrl = baseUrl;
    }

    /**
     * Retrieve site metadata/config
     * @return OK
     */
    getSiteMetadata(): Observable<SiteMetadataDto> {
        let url_ = this.baseUrl + "/site-metadata";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetSiteMetadata(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetSiteMetadata(<any>r));
                } catch (e) {
                    return <Observable<SiteMetadataDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SiteMetadataDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSiteMetadata(response: HttpResponseBase): Observable<SiteMetadataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SiteMetadataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class XsrfTokenApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return XsrfTokenApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) XsrfTokenApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api";
    }

    static init(baseUrl: string){
        XsrfTokenApiClient._baseUrl = baseUrl;
    }

    /**
     * Get the XSRF token
     * @return OK
     */
    getXsrfToken(): Observable<string> {
        let url_ = this.baseUrl + "/xsrf-token";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetXsrfToken(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetXsrfToken(<any>r));
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetXsrfToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ErrorLogApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return ErrorLogApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) ErrorLogApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api";
    }

    static init(baseUrl: string){
        ErrorLogApiClient._baseUrl = baseUrl;
    }

    /**
     * Log a client-side error
     * @param body (optional) 
     * @return OK
     */
    logError(body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/errorLog";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processLogError(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processLogError(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLogError(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaymentsApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return PaymentsApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) PaymentsApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api";
    }

    static init(baseUrl: string){
        PaymentsApiClient._baseUrl = baseUrl;
    }

    /**
     * Retrieve a lsit of all payments for this specific user
     * @param userId (optional) User Id of the user to grab payments for. If not passed will default to pulling from the currently signed in user
     * @return OK
     */
    getUserPayments(userId: number | undefined): Observable<PaymentSummaryDto[]> {
        let url_ = this.baseUrl + "/payments/user/{UserId}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (userId !== null && userId !== undefined)
        url_ = url_.replace("{UserId}", encodeURIComponent("" + userId));
        else
            url_ = url_.replace("/{UserId}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetUserPayments(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetUserPayments(<any>r));
                } catch (e) {
                    return <Observable<PaymentSummaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentSummaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserPayments(response: HttpResponseBase): Observable<PaymentSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve a specific payment
     * @param paymentIdentifier Unique identifier for the payment.
     * @return OK
     */
    getPaymentDetails(paymentIdentifier: string): Observable<PaymentDetailsDto> {
        let url_ = this.baseUrl + "/payments/{PaymentIdentifier}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (paymentIdentifier === undefined || paymentIdentifier === null)
            throw new Error("The parameter 'paymentIdentifier' must be defined.");
        url_ = url_.replace("{PaymentIdentifier}", encodeURIComponent("" + paymentIdentifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPaymentDetails(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPaymentDetails(<any>r));
                } catch (e) {
                    return <Observable<PaymentDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentDetails(response: HttpResponseBase): Observable<PaymentDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UsersApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return UsersApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) UsersApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api";
    }

    static init(baseUrl: string){
        UsersApiClient._baseUrl = baseUrl;
    }

    /**
     * Retrieve information about personal user info for display on a "personal info" page
     * @param userId Unique (TellerOnline) ID of user
     * @return OK
     */
    getUserProfile(userId: number): Observable<UserProfileDto> {
        let url_ = this.baseUrl + "/users/{UserId}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{UserId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetUserProfile(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetUserProfile(<any>r));
                } catch (e) {
                    return <Observable<UserProfileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserProfileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserProfile(response: HttpResponseBase): Observable<UserProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retreieve user's payment methods
     * @param userId (optional) Unique ID of user
     * @return OK
     */
    getUserPaymentMethods(userId: number | null | undefined): Observable<PaymentMethodDto[]> {
        let url_ = this.baseUrl + "/user/payment-methods?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetUserPaymentMethods(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetUserPaymentMethods(<any>r));
                } catch (e) {
                    return <Observable<PaymentMethodDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentMethodDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserPaymentMethods(response: HttpResponseBase): Observable<PaymentMethodDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentMethodDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class PaymentMethodDto implements IPaymentMethodDto {
    /** The unique ID of a payment method */
    paymentMethodId!: number;
    /** The card brand */
    cardType?: string;
    /** The expiry month/year of the card */
    cardExpiry?: string;
    /** The last 4 digits of the credit card number */
    last4Digits?: string;
    /** Payment method type (CreditCard or ECheck) */
    paymentMethodType?: PaymentMethodTypeEnumDto;
    /** eCheck Account Type */
    eCheckAccountType?: ECheckAccountTypeEnumDto;
    /** eCheck Account Owner Type */
    eCheckAccountOwnerType?: ECheckAccountOwnerTypeEnumDto;
    /** Routing number */
    eCheckRoutingNumber?: string;
    /** Account Number */
    eCheckAccountNumber?: string;
    /** The first line of the Address (e.g. 27 Merry Ln) */
    addressLine1?: string;
    /** The second line of the Address (e.g. Suite 202) */
    addressLine2?: string;
    /** Zip code */
    addressZip?: string;
    /** City */
    addressCity?: string;
    /** Country */
    addressCountry?: string;
    /** ISO Country Code */
    addressCountryCode?: string;
    /** State */
    addressState?: string;
    /** State code */
    addressStateCode?: string;
    /** Phone */
    phone?: string;
    /** Full name */
    fullName?: string;
    /** Indicates if the payment method is default one for the user */
    isDefault?: any;

    [key: string]: any;

    constructor(data?: IPaymentMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.paymentMethodId = _data["paymentMethodId"];
            this.cardType = _data["cardType"];
            this.cardExpiry = _data["cardExpiry"];
            this.last4Digits = _data["last4Digits"];
            this.paymentMethodType = _data["paymentMethodType"];
            this.eCheckAccountType = _data["eCheckAccountType"];
            this.eCheckAccountOwnerType = _data["eCheckAccountOwnerType"];
            this.eCheckRoutingNumber = _data["eCheckRoutingNumber"];
            this.eCheckAccountNumber = _data["eCheckAccountNumber"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.addressZip = _data["addressZip"];
            this.addressCity = _data["addressCity"];
            this.addressCountry = _data["addressCountry"];
            this.addressCountryCode = _data["addressCountryCode"];
            this.addressState = _data["addressState"];
            this.addressStateCode = _data["addressStateCode"];
            this.phone = _data["phone"];
            this.fullName = _data["fullName"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): PaymentMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["paymentMethodId"] = this.paymentMethodId;
        data["cardType"] = this.cardType;
        data["cardExpiry"] = this.cardExpiry;
        data["last4Digits"] = this.last4Digits;
        data["paymentMethodType"] = this.paymentMethodType;
        data["eCheckAccountType"] = this.eCheckAccountType;
        data["eCheckAccountOwnerType"] = this.eCheckAccountOwnerType;
        data["eCheckRoutingNumber"] = this.eCheckRoutingNumber;
        data["eCheckAccountNumber"] = this.eCheckAccountNumber;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["addressZip"] = this.addressZip;
        data["addressCity"] = this.addressCity;
        data["addressCountry"] = this.addressCountry;
        data["addressCountryCode"] = this.addressCountryCode;
        data["addressState"] = this.addressState;
        data["addressStateCode"] = this.addressStateCode;
        data["phone"] = this.phone;
        data["fullName"] = this.fullName;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IPaymentMethodDto {
    /** The unique ID of a payment method */
    paymentMethodId: number;
    /** The card brand */
    cardType?: string;
    /** The expiry month/year of the card */
    cardExpiry?: string;
    /** The last 4 digits of the credit card number */
    last4Digits?: string;
    /** Payment method type (CreditCard or ECheck) */
    paymentMethodType?: PaymentMethodTypeEnumDto;
    /** eCheck Account Type */
    eCheckAccountType?: ECheckAccountTypeEnumDto;
    /** eCheck Account Owner Type */
    eCheckAccountOwnerType?: ECheckAccountOwnerTypeEnumDto;
    /** Routing number */
    eCheckRoutingNumber?: string;
    /** Account Number */
    eCheckAccountNumber?: string;
    /** The first line of the Address (e.g. 27 Merry Ln) */
    addressLine1?: string;
    /** The second line of the Address (e.g. Suite 202) */
    addressLine2?: string;
    /** Zip code */
    addressZip?: string;
    /** City */
    addressCity?: string;
    /** Country */
    addressCountry?: string;
    /** ISO Country Code */
    addressCountryCode?: string;
    /** State */
    addressState?: string;
    /** State code */
    addressStateCode?: string;
    /** Phone */
    phone?: string;
    /** Full name */
    fullName?: string;
    /** Indicates if the payment method is default one for the user */
    isDefault?: any;

    [key: string]: any;
}

/** Status of a cart. */
export enum PaymentTypeEnumDto {
    CreditCard = "CreditCard",
    ECheck = "ECheck",
}

/** Settings used for searching/filtering a list of payments */
export class SearchSettingsDto implements ISearchSettingsDto {
    filters!: SearchFilterDto[];
    /** A string to search by */
    search?: string;
    /** The column that is being sorted by currently, optional, null if not provided */
    sortColumn?: string;
    /** The direction to sort by. Defaults to ascending */
    sortDirection?: string;
    /** How many results to return per page loaded */
    pageSize!: number;
    /** The index of which page to load */
    pageIndex!: number;

    [key: string]: any;

    constructor(data?: ISearchSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.filters = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(SearchFilterDto.fromJS(item));
            }
            this.search = _data["search"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
        }
    }

    static fromJS(data: any): SearchSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["search"] = this.search;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        return data;
    }
}

/** Settings used for searching/filtering a list of payments */
export interface ISearchSettingsDto {
    filters: SearchFilterDto[];
    /** A string to search by */
    search?: string;
    /** The column that is being sorted by currently, optional, null if not provided */
    sortColumn?: string;
    /** The direction to sort by. Defaults to ascending */
    sortDirection?: string;
    /** How many results to return per page loaded */
    pageSize: number;
    /** The index of which page to load */
    pageIndex: number;

    [key: string]: any;
}

/** Status of a cart. */
export enum CartStatusEnumDto {
    Open = "Open",
    CheckingOut = "CheckingOut",
    Processing = "Processing",
    Finalized = "Finalized",
    Closed = "Closed",
}

/** Supported payment method types */
export enum PaymentMethodTypeEnumDto {
    CreditCard = "CreditCard",
    ECheck = "ECheck",
    Undetermined = "Undetermined",
}

/** Allowed Account Types for EChecks */
export enum ECheckAccountTypeEnumDto {
    Checking = "Checking",
    Savings = "Savings",
}

/** Allowed Account Ownership Types for EChecks */
export enum ECheckAccountOwnerTypeEnumDto {
    Personal = "Personal",
    Business = "Business",
}

/** Possible filters that can be applied to a search */
export enum PaymentsSearchOptionsEnumDto {
    MaxTotal = "MaxTotal",
    MinTotal = "MinTotal",
    Status = "Status",
    OneOfStatus = "OneOfStatus",
    StartDate = "StartDate",
    EndDate = "EndDate",
    HasNoEndDate = "HasNoEndDate",
}

/** A possible filter to apply to a search */
export class SearchFilterDto implements ISearchFilterDto {
    type?: PaymentsSearchOptionsEnumDto;
    value?: string;

    [key: string]: any;

    constructor(data?: ISearchFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SearchFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

/** A possible filter to apply to a search */
export interface ISearchFilterDto {
    type?: PaymentsSearchOptionsEnumDto;
    value?: string;

    [key: string]: any;
}

/** Data shown on the footer */
export class FooterLinkDataDto implements IFooterLinkDataDto {
    /** Link title */
    title?: string;
    /** URL of the footer link */
    url?: string;

    [key: string]: any;

    constructor(data?: IFooterLinkDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.title = _data["title"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): FooterLinkDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new FooterLinkDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["title"] = this.title;
        data["url"] = this.url;
        return data;
    }
}

/** Data shown on the footer */
export interface IFooterLinkDataDto {
    /** Link title */
    title?: string;
    /** URL of the footer link */
    url?: string;

    [key: string]: any;
}

/** The site customization */
export class SiteCustomizationDto implements ISiteCustomizationDto {
    /** Client title */
    title?: string;
    /** Portal Name */
    subtitle?: string;
    /** Client copyright text */
    copyrightText?: string;
    /** Content to display on the home page banner (Markdown) */
    homeBannerContent?: string;
    /** The links to display in the footer */
    footerLinksContent?: FooterLinkDataDto[];
    /** Text of additional info (Markdown) */
    additionalInfo?: string;
    /** Disclaimer to be displayed in the cart panel/as a popup (if longer than 2 lines) */
    cartDisclaimer?: string;
    /** Disclaimer to notify the user that their cart will be split into multiple payments */
    multiPaymentDisclaimer?: string;
    /** Email address that messages are sent from */
    fromEmail?: string;
    /** Display name shown on emails */
    fromEmailDisplay?: string;

    [key: string]: any;

    constructor(data?: ISiteCustomizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.title = _data["title"];
            this.subtitle = _data["subtitle"];
            this.copyrightText = _data["copyrightText"];
            this.homeBannerContent = _data["homeBannerContent"];
            if (Array.isArray(_data["footerLinksContent"])) {
                this.footerLinksContent = [] as any;
                for (let item of _data["footerLinksContent"])
                    this.footerLinksContent!.push(FooterLinkDataDto.fromJS(item));
            }
            this.additionalInfo = _data["additionalInfo"];
            this.cartDisclaimer = _data["cartDisclaimer"];
            this.multiPaymentDisclaimer = _data["multiPaymentDisclaimer"];
            this.fromEmail = _data["fromEmail"];
            this.fromEmailDisplay = _data["fromEmailDisplay"];
        }
    }

    static fromJS(data: any): SiteCustomizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SiteCustomizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["copyrightText"] = this.copyrightText;
        data["homeBannerContent"] = this.homeBannerContent;
        if (Array.isArray(this.footerLinksContent)) {
            data["footerLinksContent"] = [];
            for (let item of this.footerLinksContent)
                data["footerLinksContent"].push(item.toJSON());
        }
        data["additionalInfo"] = this.additionalInfo;
        data["cartDisclaimer"] = this.cartDisclaimer;
        data["multiPaymentDisclaimer"] = this.multiPaymentDisclaimer;
        data["fromEmail"] = this.fromEmail;
        data["fromEmailDisplay"] = this.fromEmailDisplay;
        return data;
    }
}

/** The site customization */
export interface ISiteCustomizationDto {
    /** Client title */
    title?: string;
    /** Portal Name */
    subtitle?: string;
    /** Client copyright text */
    copyrightText?: string;
    /** Content to display on the home page banner (Markdown) */
    homeBannerContent?: string;
    /** The links to display in the footer */
    footerLinksContent?: FooterLinkDataDto[];
    /** Text of additional info (Markdown) */
    additionalInfo?: string;
    /** Disclaimer to be displayed in the cart panel/as a popup (if longer than 2 lines) */
    cartDisclaimer?: string;
    /** Disclaimer to notify the user that their cart will be split into multiple payments */
    multiPaymentDisclaimer?: string;
    /** Email address that messages are sent from */
    fromEmail?: string;
    /** Display name shown on emails */
    fromEmailDisplay?: string;

    [key: string]: any;
}

/** The menu items configured in the online system */
export class MenuItemDto implements IMenuItemDto {
    /** Unique identifier for the menu item */
    menuItemId?: number;
    /** The page ID associated with this menu item */
    pageId?: number;
    /** Display label for the menu item */
    label?: string;
    /** Short description of the menu item */
    description?: string;
    /** Order in which the menu item should be displayed */
    displayOrder?: number;
    /** Whether the menu item is active */
    active?: boolean;
    /** The public portal site ID this menu item belongs to */
    publicPortalSiteId?: number;

    [key: string]: any;

    constructor(data?: IMenuItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.menuItemId = _data["menuItemId"];
            this.pageId = _data["pageId"];
            this.label = _data["label"];
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
            this.active = _data["active"];
            this.publicPortalSiteId = _data["publicPortalSiteId"];
        }
    }

    static fromJS(data: any): MenuItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MenuItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["menuItemId"] = this.menuItemId;
        data["pageId"] = this.pageId;
        data["label"] = this.label;
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        data["active"] = this.active;
        data["publicPortalSiteId"] = this.publicPortalSiteId;
        return data;
    }
}

/** The menu items configured in the online system */
export interface IMenuItemDto {
    /** Unique identifier for the menu item */
    menuItemId?: number;
    /** The page ID associated with this menu item */
    pageId?: number;
    /** Display label for the menu item */
    label?: string;
    /** Short description of the menu item */
    description?: string;
    /** Order in which the menu item should be displayed */
    displayOrder?: number;
    /** Whether the menu item is active */
    active?: boolean;
    /** The public portal site ID this menu item belongs to */
    publicPortalSiteId?: number;

    [key: string]: any;
}

/** What is the currently active payment integration */
export enum PaymentIntegrationEnumDto {
    Demo = "Demo",
    Nic = "Nic",
    Datacap = "Datacap",
    Celero = "Celero",
    BridgePay = "BridgePay",
    Elavon = "Elavon",
    PointAndPay = "PointAndPay",
    CyberSource = "CyberSource",
    WellsFargo = "WellsFargo",
    Fis = "Fis",
    Paymentus = "Paymentus",
    InvoiceCloud = "InvoiceCloud",
    Govolution = "Govolution",
    MSB = "MSB",
    Fiserv = "Fiserv",
    LexisNexis = "LexisNexis",
    Generic = "Generic",
}

/** The password policy settings from Cognito */
export class PasswordPolicyDto implements IPasswordPolicyDto {
    /** Minimum length that the password must be */
    minimumLength?: number;
    /** If the password must contain at least one lowercase letter */
    requireLowercase?: any;
    /** If the password must contain at least one uppercase letter */
    requireUppercase?: any;
    /** If the password must contain at least one number */
    requireNumbers?: any;
    /** If the password must contain at least one symbol in the following set (  -=+^$*.[]{}()?"!@#%&/\,><':;|_~`  ) */
    requireSymbols?: any;

    [key: string]: any;

    constructor(data?: IPasswordPolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.minimumLength = _data["minimumLength"];
            this.requireLowercase = _data["requireLowercase"];
            this.requireUppercase = _data["requireUppercase"];
            this.requireNumbers = _data["requireNumbers"];
            this.requireSymbols = _data["requireSymbols"];
        }
    }

    static fromJS(data: any): PasswordPolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordPolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["minimumLength"] = this.minimumLength;
        data["requireLowercase"] = this.requireLowercase;
        data["requireUppercase"] = this.requireUppercase;
        data["requireNumbers"] = this.requireNumbers;
        data["requireSymbols"] = this.requireSymbols;
        return data;
    }
}

/** The password policy settings from Cognito */
export interface IPasswordPolicyDto {
    /** Minimum length that the password must be */
    minimumLength?: number;
    /** If the password must contain at least one lowercase letter */
    requireLowercase?: any;
    /** If the password must contain at least one uppercase letter */
    requireUppercase?: any;
    /** If the password must contain at least one number */
    requireNumbers?: any;
    /** If the password must contain at least one symbol in the following set (  -=+^$*.[]{}()?"!@#%&/\,><':;|_~`  ) */
    requireSymbols?: any;

    [key: string]: any;
}

/** Convenience fee configuration for the site */
export class BaseConvenienceFeeConfigDto implements IBaseConvenienceFeeConfigDto {
    /** Unique identifier for this configuration to be used when attempting 
to override the payment config for a subset of items in the cart.
 */
    configKey?: string;
    /** Whether or not we will calculate the convenience fee on our side
True: we will calculate (approximate) it ahead of time to display
False: the fee will only be calculated in the payment portal
 */
    convenienceFeeEnabled?: boolean;
    /** An alternate label to use in place of the default "Convenience Fee" */
    convenienceFeeLabel?: string;
    /** The message to display next to the convenience fee item (via the "i" icon) */
    convenienceFeeNote?: string;
    /** What format the rate is stored as (percent, flat, other) */
    convenienceFeeFormat?: string;
    /** The rate the convenience fee is charged at
Stored as a representation matching the format
e.g. 3% would be 0.03, $50 would be 50
Use format "other" when the fee is not pre-calculated from a standard
rate (e.g. computed by the Teller plugin per partition); the rate field
is unused in that case.
 */
    convenienceFeeRate?: number;

    [key: string]: any;

    constructor(data?: IBaseConvenienceFeeConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.configKey = _data["configKey"];
            this.convenienceFeeEnabled = _data["convenienceFeeEnabled"];
            this.convenienceFeeLabel = _data["convenienceFeeLabel"];
            this.convenienceFeeNote = _data["convenienceFeeNote"];
            this.convenienceFeeFormat = _data["convenienceFeeFormat"];
            this.convenienceFeeRate = _data["convenienceFeeRate"];
        }
    }

    static fromJS(data: any): BaseConvenienceFeeConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseConvenienceFeeConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["configKey"] = this.configKey;
        data["convenienceFeeEnabled"] = this.convenienceFeeEnabled;
        data["convenienceFeeLabel"] = this.convenienceFeeLabel;
        data["convenienceFeeNote"] = this.convenienceFeeNote;
        data["convenienceFeeFormat"] = this.convenienceFeeFormat;
        data["convenienceFeeRate"] = this.convenienceFeeRate;
        return data;
    }
}

/** Convenience fee configuration for the site */
export interface IBaseConvenienceFeeConfigDto {
    /** Unique identifier for this configuration to be used when attempting 
to override the payment config for a subset of items in the cart.
 */
    configKey?: string;
    /** Whether or not we will calculate the convenience fee on our side
True: we will calculate (approximate) it ahead of time to display
False: the fee will only be calculated in the payment portal
 */
    convenienceFeeEnabled?: boolean;
    /** An alternate label to use in place of the default "Convenience Fee" */
    convenienceFeeLabel?: string;
    /** The message to display next to the convenience fee item (via the "i" icon) */
    convenienceFeeNote?: string;
    /** What format the rate is stored as (percent, flat, other) */
    convenienceFeeFormat?: string;
    /** The rate the convenience fee is charged at
Stored as a representation matching the format
e.g. 3% would be 0.03, $50 would be 50
Use format "other" when the fee is not pre-calculated from a standard
rate (e.g. computed by the Teller plugin per partition); the rate field
is unused in that case.
 */
    convenienceFeeRate?: number;

    [key: string]: any;
}

export class ConvenienceFeeConfigDto extends BaseConvenienceFeeConfigDto implements IConvenienceFeeConfigDto {
    creditConfig?: BaseConvenienceFeeConfigDto;
    eCheckConfig?: BaseConvenienceFeeConfigDto;

    [key: string]: any;

    constructor(data?: IConvenienceFeeConfigDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.creditConfig = _data["creditConfig"] ? BaseConvenienceFeeConfigDto.fromJS(_data["creditConfig"]) : <any>undefined;
            this.eCheckConfig = _data["eCheckConfig"] ? BaseConvenienceFeeConfigDto.fromJS(_data["eCheckConfig"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConvenienceFeeConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConvenienceFeeConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["creditConfig"] = this.creditConfig ? this.creditConfig.toJSON() : <any>undefined;
        data["eCheckConfig"] = this.eCheckConfig ? this.eCheckConfig.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IConvenienceFeeConfigDto extends IBaseConvenienceFeeConfigDto {
    creditConfig?: BaseConvenienceFeeConfigDto;
    eCheckConfig?: BaseConvenienceFeeConfigDto;

    [key: string]: any;
}

/** CloudWatch RUM (real-user monitoring) settings for the browser. Absent, or enabled=false, when the environment has no RUM app monitor. */
export class RumConfigurationDto implements IRumConfigurationDto {
    /** When false the frontend must not initialise RUM. */
    enabled!: boolean;
    /** The RUM app monitor id (application id for the web client). */
    appMonitorId?: string;
    /** Sent as the alias of every unsigned batch. The app monitor's resource policy
accepts unsigned PutRumEvents only with this value.
 */
    alias?: string;
    /** AWS region of the app monitor. */
    region?: string;
    /** Fraction of sessions to record, from 0 to 1. */
    sessionSampleRate?: number;
    /** Environment label attached to every event (e.g. demo). */
    environment?: string;

    [key: string]: any;

    constructor(data?: IRumConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.enabled = _data["enabled"];
            this.appMonitorId = _data["appMonitorId"];
            this.alias = _data["alias"];
            this.region = _data["region"];
            this.sessionSampleRate = _data["sessionSampleRate"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): RumConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RumConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["enabled"] = this.enabled;
        data["appMonitorId"] = this.appMonitorId;
        data["alias"] = this.alias;
        data["region"] = this.region;
        data["sessionSampleRate"] = this.sessionSampleRate;
        data["environment"] = this.environment;
        return data;
    }
}

/** CloudWatch RUM (real-user monitoring) settings for the browser. Absent, or enabled=false, when the environment has no RUM app monitor. */
export interface IRumConfigurationDto {
    /** When false the frontend must not initialise RUM. */
    enabled: boolean;
    /** The RUM app monitor id (application id for the web client). */
    appMonitorId?: string;
    /** Sent as the alias of every unsigned batch. The app monitor's resource policy
accepts unsigned PutRumEvents only with this value.
 */
    alias?: string;
    /** AWS region of the app monitor. */
    region?: string;
    /** Fraction of sessions to record, from 0 to 1. */
    sessionSampleRate?: number;
    /** Environment label attached to every event (e.g. demo). */
    environment?: string;

    [key: string]: any;
}

/** Configuration of the Public Portal Backend */
export class AppConfigurationDto implements IAppConfigurationDto {
    /** The country used as the default value for any country dropdown throughout the app */
    defaultCountry?: string;
    /** The state used as the default value for any state/province dropdown throughout the app */
    defaultState?: string;
    /** The code to use for reCAPTCHA validation on the frontend */
    captchaClientSideKey?: string;
    /** name of the active credit card processor */
    creditProcessor?: PaymentIntegrationEnumDto;
    /** name of the active e-check processor */
    eCheckProcessor?: PaymentIntegrationEnumDto;
    passwordPolicy?: PasswordPolicyDto;
    convenienceFeeConfig?: ConvenienceFeeConfigDto[];
    /** When true, the payment authorization disclosure is presented in a modal;
when false (default) it is shown inline above the submit button.
 */
    presentConsentInModal?: boolean;
    /** When true, paying with a saved credit card requires per-payment
authorization consent; when false (default) the save-time authorization
covers future payments and no consent is shown or recorded per payment.
 */
    requireSavedMethodReauthorizationCreditCard?: boolean;
    /** When true, paying with a saved eCheck requires per-payment authorization
consent; when false (default) the save-time authorization covers future
payments and no consent is shown or recorded per payment.
 */
    requireSavedMethodReauthorizationECheck?: boolean;
    /** When true (default), the payment receipt offers to link the accounts behind the
items just paid for. When false the receipt shows no such offer; the search page
is not affected.
 */
    offerAccountLinkingAfterCheckout?: boolean;
    /** Maximum size, in bytes, allowed for a single uploaded attachment. The frontend
enforces this as a hard cap and derives the "Max N MB per file" label from it; a
per-field limit may further restrict it.
 */
    maxUploadFileSizeBytes?: number;
    rum?: RumConfigurationDto;

    [key: string]: any;

    constructor(data?: IAppConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.defaultCountry = _data["defaultCountry"];
            this.defaultState = _data["defaultState"];
            this.captchaClientSideKey = _data["captchaClientSideKey"];
            this.creditProcessor = _data["creditProcessor"];
            this.eCheckProcessor = _data["eCheckProcessor"];
            this.passwordPolicy = _data["passwordPolicy"] ? PasswordPolicyDto.fromJS(_data["passwordPolicy"]) : <any>undefined;
            if (Array.isArray(_data["convenienceFeeConfig"])) {
                this.convenienceFeeConfig = [] as any;
                for (let item of _data["convenienceFeeConfig"])
                    this.convenienceFeeConfig!.push(ConvenienceFeeConfigDto.fromJS(item));
            }
            this.presentConsentInModal = _data["presentConsentInModal"];
            this.requireSavedMethodReauthorizationCreditCard = _data["requireSavedMethodReauthorizationCreditCard"];
            this.requireSavedMethodReauthorizationECheck = _data["requireSavedMethodReauthorizationECheck"];
            this.offerAccountLinkingAfterCheckout = _data["offerAccountLinkingAfterCheckout"];
            this.maxUploadFileSizeBytes = _data["maxUploadFileSizeBytes"];
            this.rum = _data["rum"] ? RumConfigurationDto.fromJS(_data["rum"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["defaultCountry"] = this.defaultCountry;
        data["defaultState"] = this.defaultState;
        data["captchaClientSideKey"] = this.captchaClientSideKey;
        data["creditProcessor"] = this.creditProcessor;
        data["eCheckProcessor"] = this.eCheckProcessor;
        data["passwordPolicy"] = this.passwordPolicy ? this.passwordPolicy.toJSON() : <any>undefined;
        if (Array.isArray(this.convenienceFeeConfig)) {
            data["convenienceFeeConfig"] = [];
            for (let item of this.convenienceFeeConfig)
                data["convenienceFeeConfig"].push(item.toJSON());
        }
        data["presentConsentInModal"] = this.presentConsentInModal;
        data["requireSavedMethodReauthorizationCreditCard"] = this.requireSavedMethodReauthorizationCreditCard;
        data["requireSavedMethodReauthorizationECheck"] = this.requireSavedMethodReauthorizationECheck;
        data["offerAccountLinkingAfterCheckout"] = this.offerAccountLinkingAfterCheckout;
        data["maxUploadFileSizeBytes"] = this.maxUploadFileSizeBytes;
        data["rum"] = this.rum ? this.rum.toJSON() : <any>undefined;
        return data;
    }
}

/** Configuration of the Public Portal Backend */
export interface IAppConfigurationDto {
    /** The country used as the default value for any country dropdown throughout the app */
    defaultCountry?: string;
    /** The state used as the default value for any state/province dropdown throughout the app */
    defaultState?: string;
    /** The code to use for reCAPTCHA validation on the frontend */
    captchaClientSideKey?: string;
    /** name of the active credit card processor */
    creditProcessor?: PaymentIntegrationEnumDto;
    /** name of the active e-check processor */
    eCheckProcessor?: PaymentIntegrationEnumDto;
    passwordPolicy?: PasswordPolicyDto;
    convenienceFeeConfig?: ConvenienceFeeConfigDto[];
    /** When true, the payment authorization disclosure is presented in a modal;
when false (default) it is shown inline above the submit button.
 */
    presentConsentInModal?: boolean;
    /** When true, paying with a saved credit card requires per-payment
authorization consent; when false (default) the save-time authorization
covers future payments and no consent is shown or recorded per payment.
 */
    requireSavedMethodReauthorizationCreditCard?: boolean;
    /** When true, paying with a saved eCheck requires per-payment authorization
consent; when false (default) the save-time authorization covers future
payments and no consent is shown or recorded per payment.
 */
    requireSavedMethodReauthorizationECheck?: boolean;
    /** When true (default), the payment receipt offers to link the accounts behind the
items just paid for. When false the receipt shows no such offer; the search page
is not affected.
 */
    offerAccountLinkingAfterCheckout?: boolean;
    /** Maximum size, in bytes, allowed for a single uploaded attachment. The frontend
enforces this as a hard cap and derives the "Max N MB per file" label from it; a
per-field limit may further restrict it.
 */
    maxUploadFileSizeBytes?: number;
    rum?: RumConfigurationDto;

    [key: string]: any;
}

/** Available portal features */
export class PortalFeatureDto implements IPortalFeatureDto {
    /** Name of the feature */
    name?: string;
    /** Is the feature enabled or not */
    enabled?: any;

    [key: string]: any;

    constructor(data?: IPortalFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): PortalFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["enabled"] = this.enabled;
        return data;
    }
}

/** Available portal features */
export interface IPortalFeatureDto {
    /** Name of the feature */
    name?: string;
    /** Is the feature enabled or not */
    enabled?: any;

    [key: string]: any;
}

/** A pattern an identifier value must match, with the message to show when it does not. */
export class AccountFetchFieldValidationDto implements IAccountFetchFieldValidationDto {
    /** The pattern. The server anchors it to the whole value and is authoritative; a browser check
of the same pattern is looser because Angular anchors without grouping it, so a value the
browser accepts may still be rejected on submit.
 */
    regex?: string;
    /** What to tell the user when the value does not match. */
    message?: string;

    [key: string]: any;

    constructor(data?: IAccountFetchFieldValidationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.regex = _data["regex"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): AccountFetchFieldValidationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountFetchFieldValidationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["regex"] = this.regex;
        data["message"] = this.message;
        return data;
    }
}

/** A pattern an identifier value must match, with the message to show when it does not. */
export interface IAccountFetchFieldValidationDto {
    /** The pattern. The server anchors it to the whole value and is authoritative; a browser check
of the same pattern is looser because Angular anchors without grouping it, so a value the
browser accepts may still be rejected on submit.
 */
    regex?: string;
    /** What to tell the user when the value does not match. */
    message?: string;

    [key: string]: any;
}

/** One identifier input the page's account-fetch template declares. Enough to render the field and give the user the guidance the server enforces; the template on the server stays the authority on what may be searched on. */
export class AccountFetchFieldDto implements IAccountFetchFieldDto {
    /** The template's field name. The key this field's value must be sent under in the link call's
`searches` map.
 */
    name?: string;
    /** Label to show. Falls back to the field name when the template gives none. */
    label?: string;
    /** Which input to render — `textbox`, `numeric` or `password`. */
    widgetType?: string;
    /** Whether the template marks this field mandatory. */
    isRequired?: boolean;
    /** Whether the value keeps its whitespace instead of being trimmed. */
    allowWhitespace?: boolean;
    /** Format guidance to show beneath the field, e.g. "ex. 12345-678 or 12345678". */
    example?: string;
    /** Patterns the value must match. A browser form enforces the first of them; the server enforces
all of them when the account is linked.
 */
    validations?: AccountFetchFieldValidationDto[];

    [key: string]: any;

    constructor(data?: IAccountFetchFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.label = _data["label"];
            this.widgetType = _data["widgetType"];
            this.isRequired = _data["isRequired"];
            this.allowWhitespace = _data["allowWhitespace"];
            this.example = _data["example"];
            if (Array.isArray(_data["validations"])) {
                this.validations = [] as any;
                for (let item of _data["validations"])
                    this.validations!.push(AccountFetchFieldValidationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountFetchFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountFetchFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["label"] = this.label;
        data["widgetType"] = this.widgetType;
        data["isRequired"] = this.isRequired;
        data["allowWhitespace"] = this.allowWhitespace;
        data["example"] = this.example;
        if (Array.isArray(this.validations)) {
            data["validations"] = [];
            for (let item of this.validations)
                data["validations"].push(item.toJSON());
        }
        return data;
    }
}

/** One identifier input the page's account-fetch template declares. Enough to render the field and give the user the guidance the server enforces; the template on the server stays the authority on what may be searched on. */
export interface IAccountFetchFieldDto {
    /** The template's field name. The key this field's value must be sent under in the link call's
`searches` map.
 */
    name?: string;
    /** Label to show. Falls back to the field name when the template gives none. */
    label?: string;
    /** Which input to render — `textbox`, `numeric` or `password`. */
    widgetType?: string;
    /** Whether the template marks this field mandatory. */
    isRequired?: boolean;
    /** Whether the value keeps its whitespace instead of being trimmed. */
    allowWhitespace?: boolean;
    /** Format guidance to show beneath the field, e.g. "ex. 12345-678 or 12345678". */
    example?: string;
    /** Patterns the value must match. A browser form enforces the first of them; the server enforces
all of them when the account is linked.
 */
    validations?: AccountFetchFieldValidationDto[];

    [key: string]: any;
}

/** A page whose account type can be linked to a user's profile. Lists everything a link dialog needs to offer the page and ask for the right identifiers. A page is listed only when linking could actually succeed through it, which includes its account-fetch template declaring at least one identifier. */
export class LinkablePageDto implements ILinkablePageDto {
    /** The page to link through. */
    pageId?: number;
    /** The page's display title. */
    title?: string;
    /** Account-type display name from the page, e.g. "Property Tax (APN)". */
    accountTypeName?: string;
    /** Whether an item found or paid on this page may be added by naming the item, from search
results or the receipt, instead of through the identifiers below.
 */
    allowLinkingFromItems?: boolean;
    /** The identifiers to ask for, in the order the page's template declares them.
 */
    accountFetchFields?: AccountFetchFieldDto[];

    [key: string]: any;

    constructor(data?: ILinkablePageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.pageId = _data["pageId"];
            this.title = _data["title"];
            this.accountTypeName = _data["accountTypeName"];
            this.allowLinkingFromItems = _data["allowLinkingFromItems"];
            if (Array.isArray(_data["accountFetchFields"])) {
                this.accountFetchFields = [] as any;
                for (let item of _data["accountFetchFields"])
                    this.accountFetchFields!.push(AccountFetchFieldDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LinkablePageDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkablePageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["pageId"] = this.pageId;
        data["title"] = this.title;
        data["accountTypeName"] = this.accountTypeName;
        data["allowLinkingFromItems"] = this.allowLinkingFromItems;
        if (Array.isArray(this.accountFetchFields)) {
            data["accountFetchFields"] = [];
            for (let item of this.accountFetchFields)
                data["accountFetchFields"].push(item.toJSON());
        }
        return data;
    }
}

/** A page whose account type can be linked to a user's profile. Lists everything a link dialog needs to offer the page and ask for the right identifiers. A page is listed only when linking could actually succeed through it, which includes its account-fetch template declaring at least one identifier. */
export interface ILinkablePageDto {
    /** The page to link through. */
    pageId?: number;
    /** The page's display title. */
    title?: string;
    /** Account-type display name from the page, e.g. "Property Tax (APN)". */
    accountTypeName?: string;
    /** Whether an item found or paid on this page may be added by naming the item, from search
results or the receipt, instead of through the identifiers below.
 */
    allowLinkingFromItems?: boolean;
    /** The identifiers to ask for, in the order the page's template declares them.
 */
    accountFetchFields?: AccountFetchFieldDto[];

    [key: string]: any;
}

/** Notice type */
export enum NoticeTypeEnumDto {
    Info = "Info",
    Warning = "Warning",
    Alert = "Alert",
}

/** Flag type */
export enum FlagTypeEnumDto {
    ReadOnly = "ReadOnly",
    Maintenance = "Maintenance",
}

/** Defines restrictions applied to a specific page */
export class IntegrationFlagDto implements IIntegrationFlagDto {
    /** ID of the page that access is restricted to */
    pageId?: number;
    /** The type of restriction */
    flagType?: FlagTypeEnumDto;

    [key: string]: any;

    constructor(data?: IIntegrationFlagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.pageId = _data["pageId"];
            this.flagType = _data["flagType"];
        }
    }

    static fromJS(data: any): IntegrationFlagDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationFlagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["pageId"] = this.pageId;
        data["flagType"] = this.flagType;
        return data;
    }
}

/** Defines restrictions applied to a specific page */
export interface IIntegrationFlagDto {
    /** ID of the page that access is restricted to */
    pageId?: number;
    /** The type of restriction */
    flagType?: FlagTypeEnumDto;

    [key: string]: any;
}

/** Notice to show on the portal */
export class NoticeDto implements INoticeDto {
    /** Date-time when the notice effect starts */
    startTimeUtc?: Date;
    /** Date-time when the notice effect ends */
    endTimeUtc?: Date;
    /** Message to be shown when active */
    message?: string;
    /** Priority of the notice */
    priority?: number;
    /** The type of the notice */
    noticeType?: NoticeTypeEnumDto;
    integrationFlags?: IntegrationFlagDto[];

    [key: string]: any;

    constructor(data?: INoticeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.startTimeUtc = _data["startTimeUtc"] ? new Date(_data["startTimeUtc"].toString()) : <any>undefined;
            this.endTimeUtc = _data["endTimeUtc"] ? new Date(_data["endTimeUtc"].toString()) : <any>undefined;
            this.message = _data["message"];
            this.priority = _data["priority"];
            this.noticeType = _data["noticeType"];
            if (Array.isArray(_data["integrationFlags"])) {
                this.integrationFlags = [] as any;
                for (let item of _data["integrationFlags"])
                    this.integrationFlags!.push(IntegrationFlagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NoticeDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoticeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["startTimeUtc"] = this.startTimeUtc ? this.startTimeUtc.toISOString() : <any>undefined;
        data["endTimeUtc"] = this.endTimeUtc ? this.endTimeUtc.toISOString() : <any>undefined;
        data["message"] = this.message;
        data["priority"] = this.priority;
        data["noticeType"] = this.noticeType;
        if (Array.isArray(this.integrationFlags)) {
            data["integrationFlags"] = [];
            for (let item of this.integrationFlags)
                data["integrationFlags"].push(item.toJSON());
        }
        return data;
    }
}

/** Notice to show on the portal */
export interface INoticeDto {
    /** Date-time when the notice effect starts */
    startTimeUtc?: Date;
    /** Date-time when the notice effect ends */
    endTimeUtc?: Date;
    /** Message to be shown when active */
    message?: string;
    /** Priority of the notice */
    priority?: number;
    /** The type of the notice */
    noticeType?: NoticeTypeEnumDto;
    integrationFlags?: IntegrationFlagDto[];

    [key: string]: any;
}

/** Identifies a configurable user-facing term. Values match the TerminologyEnum member names. */
export enum TerminologyNameEnumDto {
    LinkedAccount = "LinkedAccount",
}

/** A tenant-configured user-facing term, fully resolved with the shipped default already applied. Render the values verbatim where copy needs the term capitalized, and lowercase them at the use site where copy needs the term mid-sentence. */
export class TerminologyDto implements ITerminologyDto {
    /** Which term this is. */
    name?: TerminologyNameEnumDto;
    /** Singular form, e.g. "Property". */
    singular?: string;
    /** Plural form, e.g. "Properties". */
    plural?: string;

    [key: string]: any;

    constructor(data?: ITerminologyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.singular = _data["singular"];
            this.plural = _data["plural"];
        }
    }

    static fromJS(data: any): TerminologyDto {
        data = typeof data === 'object' ? data : {};
        let result = new TerminologyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["singular"] = this.singular;
        data["plural"] = this.plural;
        return data;
    }
}

/** A tenant-configured user-facing term, fully resolved with the shipped default already applied. Render the values verbatim where copy needs the term capitalized, and lowercase them at the use site where copy needs the term mid-sentence. */
export interface ITerminologyDto {
    /** Which term this is. */
    name?: TerminologyNameEnumDto;
    /** Singular form, e.g. "Property". */
    singular?: string;
    /** Plural form, e.g. "Properties". */
    plural?: string;

    [key: string]: any;
}

/** Config/metadata for the site */
export class SiteMetadataDto implements ISiteMetadataDto {
    tenantName?: string;
    /** IANA timezone ID for the tenant site (e.g. America/New_York) */
    tellerSiteTimeZoneId?: string;
    siteCustomization?: SiteCustomizationDto;
    menuItems?: MenuItemDto[];
    appConfiguration?: AppConfigurationDto;
    portalFeatures?: PortalFeatureDto[];
    /** The active pages configured for account linking, ordered by title. Empty
when the site offers no account linking.
 */
    linkablePages?: LinkablePageDto[];
    notices?: NoticeDto[];
    /** Tenant-configured user-facing terms, fully resolved with defaults
applied. Always contains exactly one entry per term, so a consumer
never has to supply a fallback.
 */
    terminology?: TerminologyDto[];

    [key: string]: any;

    constructor(data?: ISiteMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.tenantName = _data["tenantName"];
            this.tellerSiteTimeZoneId = _data["tellerSiteTimeZoneId"];
            this.siteCustomization = _data["siteCustomization"] ? SiteCustomizationDto.fromJS(_data["siteCustomization"]) : <any>undefined;
            if (Array.isArray(_data["menuItems"])) {
                this.menuItems = [] as any;
                for (let item of _data["menuItems"])
                    this.menuItems!.push(MenuItemDto.fromJS(item));
            }
            this.appConfiguration = _data["appConfiguration"] ? AppConfigurationDto.fromJS(_data["appConfiguration"]) : <any>undefined;
            if (Array.isArray(_data["portalFeatures"])) {
                this.portalFeatures = [] as any;
                for (let item of _data["portalFeatures"])
                    this.portalFeatures!.push(PortalFeatureDto.fromJS(item));
            }
            if (Array.isArray(_data["linkablePages"])) {
                this.linkablePages = [] as any;
                for (let item of _data["linkablePages"])
                    this.linkablePages!.push(LinkablePageDto.fromJS(item));
            }
            if (Array.isArray(_data["notices"])) {
                this.notices = [] as any;
                for (let item of _data["notices"])
                    this.notices!.push(NoticeDto.fromJS(item));
            }
            if (Array.isArray(_data["terminology"])) {
                this.terminology = [] as any;
                for (let item of _data["terminology"])
                    this.terminology!.push(TerminologyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SiteMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new SiteMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["tenantName"] = this.tenantName;
        data["tellerSiteTimeZoneId"] = this.tellerSiteTimeZoneId;
        data["siteCustomization"] = this.siteCustomization ? this.siteCustomization.toJSON() : <any>undefined;
        if (Array.isArray(this.menuItems)) {
            data["menuItems"] = [];
            for (let item of this.menuItems)
                data["menuItems"].push(item.toJSON());
        }
        data["appConfiguration"] = this.appConfiguration ? this.appConfiguration.toJSON() : <any>undefined;
        if (Array.isArray(this.portalFeatures)) {
            data["portalFeatures"] = [];
            for (let item of this.portalFeatures)
                data["portalFeatures"].push(item.toJSON());
        }
        if (Array.isArray(this.linkablePages)) {
            data["linkablePages"] = [];
            for (let item of this.linkablePages)
                data["linkablePages"].push(item.toJSON());
        }
        if (Array.isArray(this.notices)) {
            data["notices"] = [];
            for (let item of this.notices)
                data["notices"].push(item.toJSON());
        }
        if (Array.isArray(this.terminology)) {
            data["terminology"] = [];
            for (let item of this.terminology)
                data["terminology"].push(item.toJSON());
        }
        return data;
    }
}

/** Config/metadata for the site */
export interface ISiteMetadataDto {
    tenantName?: string;
    /** IANA timezone ID for the tenant site (e.g. America/New_York) */
    tellerSiteTimeZoneId?: string;
    siteCustomization?: SiteCustomizationDto;
    menuItems?: MenuItemDto[];
    appConfiguration?: AppConfigurationDto;
    portalFeatures?: PortalFeatureDto[];
    /** The active pages configured for account linking, ordered by title. Empty
when the site offers no account linking.
 */
    linkablePages?: LinkablePageDto[];
    notices?: NoticeDto[];
    /** Tenant-configured user-facing terms, fully resolved with defaults
applied. Always contains exactly one entry per term, so a consumer
never has to supply a fallback.
 */
    terminology?: TerminologyDto[];

    [key: string]: any;
}

/** Status of a payment. */
export enum PaymentStatusEnumDto {
    PreProcessing = "PreProcessing",
    Processing = "Processing",
    Processed = "Processed",
    ProcessingFailed = "ProcessingFailed",
    Failed = "Failed",
    Posting = "Posting",
    Posted = "Posted",
    PostingFailed = "PostingFailed",
    PendingReview = "PendingReview",
    Cancelled = "Cancelled",
    Refunded = "Refunded",
    Finalized = "Finalized",
}

/** Digital wallet flavor for a wallet-originated payment. Mirrors the backend `DigitalWalletType` domain enum on the wire as a string (NSwag-style string enum) so the same generated type is reusable across portals. */
export enum DigitalWalletTypeEnumDto {
    GooglePay = "GooglePay",
    ApplePay = "ApplePay",
}

/** A brief summary of bare minimum details for a cart in the online portal */
export class PaymentSummaryDto implements IPaymentSummaryDto {
    /** Unique value for the payment used in the payment gateway */
    paymentIdentifier?: string;
    status!: PaymentStatusEnumDto;
    /** Receipt Number in Teller */
    tellerReceiptNumber?: string;
    /** The date/time that this cart payment was done */
    paymentDate?: Date;
    /** The last time that this cart was modified (most useful for payments that are incomplete) */
    lastChangeDate?: Date;
    /** Total price that was paid for this cart */
    total?: number;
    /** Raw summed total of all the items in the cart (prior to fees) */
    subtotal?: number;
    /** Total value of the convenience fee(s) that were paid on the cart */
    convenienceFee?: number;
    /** The type and last 4 digits of the payment method used */
    paymentMethod?: string;
    paymentMethodType?: PaymentMethodTypeEnumDto;
    /** Wallet type when the payment was made via a digital wallet. Null for
regular card / eCheck payments. Surfaces in admin views so support
can distinguish wallet-originated payments from typed-card payments
at a glance (relevant for chargeback investigation, dispute handling,
and customer-service context).
 */
    digitalWalletType?: DigitalWalletTypeEnumDto;
    /** The key to determine which configuration was used */
    configKey?: string;
    /** Scheduled date if this payment belongs to a scheduled payment, as ISO date "YYYY-MM-DD" */
    scheduledDate?: string;
    /** Item title from the parent scheduled payment */
    scheduledItemTitle?: string;
    /** Status of the scheduled payment instance (Pending, Active, Processing, etc.) */
    scheduledInstanceStatus?: string;
    /** GUID of the parent scheduled payment for navigation */
    scheduledPaymentGuid?: string;
    /** GUID of the specific scheduled payment instance */
    scheduledInstanceGuid?: string;

    [key: string]: any;

    constructor(data?: IPaymentSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.paymentIdentifier = _data["paymentIdentifier"];
            this.status = _data["status"];
            this.tellerReceiptNumber = _data["tellerReceiptNumber"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : <any>undefined;
            this.lastChangeDate = _data["lastChangeDate"] ? new Date(_data["lastChangeDate"].toString()) : <any>undefined;
            this.total = _data["total"];
            this.subtotal = _data["subtotal"];
            this.convenienceFee = _data["convenienceFee"];
            this.paymentMethod = _data["paymentMethod"];
            this.paymentMethodType = _data["paymentMethodType"];
            this.digitalWalletType = _data["digitalWalletType"];
            this.configKey = _data["configKey"];
            this.scheduledDate = _data["scheduledDate"];
            this.scheduledItemTitle = _data["scheduledItemTitle"];
            this.scheduledInstanceStatus = _data["scheduledInstanceStatus"];
            this.scheduledPaymentGuid = _data["scheduledPaymentGuid"];
            this.scheduledInstanceGuid = _data["scheduledInstanceGuid"];
        }
    }

    static fromJS(data: any): PaymentSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["paymentIdentifier"] = this.paymentIdentifier;
        data["status"] = this.status;
        data["tellerReceiptNumber"] = this.tellerReceiptNumber;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["lastChangeDate"] = this.lastChangeDate ? this.lastChangeDate.toISOString() : <any>undefined;
        data["total"] = this.total;
        data["subtotal"] = this.subtotal;
        data["convenienceFee"] = this.convenienceFee;
        data["paymentMethod"] = this.paymentMethod;
        data["paymentMethodType"] = this.paymentMethodType;
        data["digitalWalletType"] = this.digitalWalletType;
        data["configKey"] = this.configKey;
        data["scheduledDate"] = this.scheduledDate;
        data["scheduledItemTitle"] = this.scheduledItemTitle;
        data["scheduledInstanceStatus"] = this.scheduledInstanceStatus;
        data["scheduledPaymentGuid"] = this.scheduledPaymentGuid;
        data["scheduledInstanceGuid"] = this.scheduledInstanceGuid;
        return data;
    }
}

/** A brief summary of bare minimum details for a cart in the online portal */
export interface IPaymentSummaryDto {
    /** Unique value for the payment used in the payment gateway */
    paymentIdentifier?: string;
    status: PaymentStatusEnumDto;
    /** Receipt Number in Teller */
    tellerReceiptNumber?: string;
    /** The date/time that this cart payment was done */
    paymentDate?: Date;
    /** The last time that this cart was modified (most useful for payments that are incomplete) */
    lastChangeDate?: Date;
    /** Total price that was paid for this cart */
    total?: number;
    /** Raw summed total of all the items in the cart (prior to fees) */
    subtotal?: number;
    /** Total value of the convenience fee(s) that were paid on the cart */
    convenienceFee?: number;
    /** The type and last 4 digits of the payment method used */
    paymentMethod?: string;
    paymentMethodType?: PaymentMethodTypeEnumDto;
    /** Wallet type when the payment was made via a digital wallet. Null for
regular card / eCheck payments. Surfaces in admin views so support
can distinguish wallet-originated payments from typed-card payments
at a glance (relevant for chargeback investigation, dispute handling,
and customer-service context).
 */
    digitalWalletType?: DigitalWalletTypeEnumDto;
    /** The key to determine which configuration was used */
    configKey?: string;
    /** Scheduled date if this payment belongs to a scheduled payment, as ISO date "YYYY-MM-DD" */
    scheduledDate?: string;
    /** Item title from the parent scheduled payment */
    scheduledItemTitle?: string;
    /** Status of the scheduled payment instance (Pending, Active, Processing, etc.) */
    scheduledInstanceStatus?: string;
    /** GUID of the parent scheduled payment for navigation */
    scheduledPaymentGuid?: string;
    /** GUID of the specific scheduled payment instance */
    scheduledInstanceGuid?: string;

    [key: string]: any;
}

export class UserProfileDto implements IUserProfileDto {
    /** Identity server user id */
    identityProviderUserId?: string;
    /** Unique user ID */
    onlineUserId?: number;
    /** The user's email */
    email?: string;
    /** The user's email is verified */
    emailVerified?: boolean;
    /** The user's name */
    name?: string;
    /** The user's phone number */
    phoneNumber?: string;
    /** The user's phone number is verified */
    phoneNumberVerified?: boolean;

    [key: string]: any;

    constructor(data?: IUserProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.identityProviderUserId = _data["identityProviderUserId"];
            this.onlineUserId = _data["onlineUserId"];
            this.email = _data["email"];
            this.emailVerified = _data["emailVerified"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberVerified = _data["phoneNumberVerified"];
        }
    }

    static fromJS(data: any): UserProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["identityProviderUserId"] = this.identityProviderUserId;
        data["onlineUserId"] = this.onlineUserId;
        data["email"] = this.email;
        data["emailVerified"] = this.emailVerified;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberVerified"] = this.phoneNumberVerified;
        return data;
    }
}

export interface IUserProfileDto {
    /** Identity server user id */
    identityProviderUserId?: string;
    /** Unique user ID */
    onlineUserId?: number;
    /** The user's email */
    email?: string;
    /** The user's email is verified */
    emailVerified?: boolean;
    /** The user's name */
    name?: string;
    /** The user's phone number */
    phoneNumber?: string;
    /** The user's phone number is verified */
    phoneNumberVerified?: boolean;

    [key: string]: any;
}

/** Summary of a payment with who made the payment. Typically used in the Admin portal for rendering a list */
export class PaymentOverviewDto implements IPaymentOverviewDto {
    summary!: PaymentSummaryDto;
    /** User who made the payment */
    user?: UserProfileDto;
    /** The email associated with the payment. Should only be present for anonymous payments */
    email?: string;

    [key: string]: any;

    constructor(data?: IPaymentOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.summary = new PaymentSummaryDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.summary = _data["summary"] ? PaymentSummaryDto.fromJS(_data["summary"]) : new PaymentSummaryDto();
            this.user = _data["user"] ? UserProfileDto.fromJS(_data["user"]) : <any>undefined;
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): PaymentOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["email"] = this.email;
        return data;
    }
}

/** Summary of a payment with who made the payment. Typically used in the Admin portal for rendering a list */
export interface IPaymentOverviewDto {
    summary: PaymentSummaryDto;
    /** User who made the payment */
    user?: UserProfileDto;
    /** The email associated with the payment. Should only be present for anonymous payments */
    email?: string;

    [key: string]: any;
}

/** Cart custom value */
export class CustomValueDto implements ICustomValueDto {
    /** Name of custom value */
    name?: string;
    /** Value of custom value */
    value?: string;

    [key: string]: any;

    constructor(data?: ICustomValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CustomValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

/** Cart custom value */
export interface ICustomValueDto {
    /** Name of custom value */
    name?: string;
    /** Value of custom value */
    value?: string;

    [key: string]: any;
}

/** A payable item (fee, tax charge, etc) */
export class ItemSummaryDto implements IItemSummaryDto {
    /** Unique GUID */
    itemGuid!: string;
    /** Unique identifier for this BSI in the external system */
    businessSystemItemKey?: string;
    /** Item Type No if this represents a Teller misc item */
    tellerItemTypeNo?: number;
    /** The line item description if this represents a Teller misc item */
    tellerItemDescription?: string;
    /** Business-related title to display for this item */
    title!: string;
    amountInCart?: number;
    /** Quantity of the items purchased */
    quantity?: number;

    [key: string]: any;

    constructor(data?: IItemSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.itemGuid = _data["itemGuid"];
            this.businessSystemItemKey = _data["businessSystemItemKey"];
            this.tellerItemTypeNo = _data["tellerItemTypeNo"];
            this.tellerItemDescription = _data["tellerItemDescription"];
            this.title = _data["title"];
            this.amountInCart = _data["amountInCart"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): ItemSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["itemGuid"] = this.itemGuid;
        data["businessSystemItemKey"] = this.businessSystemItemKey;
        data["tellerItemTypeNo"] = this.tellerItemTypeNo;
        data["tellerItemDescription"] = this.tellerItemDescription;
        data["title"] = this.title;
        data["amountInCart"] = this.amountInCart;
        data["quantity"] = this.quantity;
        return data;
    }
}

/** A payable item (fee, tax charge, etc) */
export interface IItemSummaryDto {
    /** Unique GUID */
    itemGuid: string;
    /** Unique identifier for this BSI in the external system */
    businessSystemItemKey?: string;
    /** Item Type No if this represents a Teller misc item */
    tellerItemTypeNo?: number;
    /** The line item description if this represents a Teller misc item */
    tellerItemDescription?: string;
    /** Business-related title to display for this item */
    title: string;
    amountInCart?: number;
    /** Quantity of the items purchased */
    quantity?: number;

    [key: string]: any;
}

/** Full payment details of a cart in the online portal, excluding the user. Typically used on a payment details page/receipt */
export class PaymentDetailsDto implements IPaymentDetailsDto {
    overview?: PaymentOverviewDto;
    /** Sign-up token associated with the payment */
    signUpToken?: string;
    /** Current failure message while processing the payment */
    currentFailureMessage?: string;
    /** List of names and values from PaymentCustomValue */
    paymentCustomValue?: CustomValueDto[];
    /** The items in the cart */
    items?: ItemSummaryDto[];

    [key: string]: any;

    constructor(data?: IPaymentDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.overview = _data["overview"] ? PaymentOverviewDto.fromJS(_data["overview"]) : <any>undefined;
            this.signUpToken = _data["signUpToken"];
            this.currentFailureMessage = _data["currentFailureMessage"];
            if (Array.isArray(_data["paymentCustomValue"])) {
                this.paymentCustomValue = [] as any;
                for (let item of _data["paymentCustomValue"])
                    this.paymentCustomValue!.push(CustomValueDto.fromJS(item));
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ItemSummaryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaymentDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["overview"] = this.overview ? this.overview.toJSON() : <any>undefined;
        data["signUpToken"] = this.signUpToken;
        data["currentFailureMessage"] = this.currentFailureMessage;
        if (Array.isArray(this.paymentCustomValue)) {
            data["paymentCustomValue"] = [];
            for (let item of this.paymentCustomValue)
                data["paymentCustomValue"].push(item.toJSON());
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

/** Full payment details of a cart in the online portal, excluding the user. Typically used on a payment details page/receipt */
export interface IPaymentDetailsDto {
    overview?: PaymentOverviewDto;
    /** Sign-up token associated with the payment */
    signUpToken?: string;
    /** Current failure message while processing the payment */
    currentFailureMessage?: string;
    /** List of names and values from PaymentCustomValue */
    paymentCustomValue?: CustomValueDto[];
    /** The items in the cart */
    items?: ItemSummaryDto[];

    [key: string]: any;
}

/** Active authorization-text version data returned to the frontend for display at consent time. Returned by GET /authorization-text/active for the requested (paymentMethodType, authorizationType); also echoed inline in error responses when a stale-version rejection happens, so the consent component can re-render onto the new active version without a full page refresh. */
export class ActiveAuthorizationTextDto implements IActiveAuthorizationTextDto {
    /** Id of the active AuthorizationTextVersion. */
    versionId!: number;
    /** Exact text to display to the user. The client must echo this verbatim
back on the consent submission so the server can hash-compare against
its stored hash.
 */
    text!: string;

    [key: string]: any;

    constructor(data?: IActiveAuthorizationTextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.versionId = _data["versionId"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): ActiveAuthorizationTextDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveAuthorizationTextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["versionId"] = this.versionId;
        data["text"] = this.text;
        return data;
    }
}

/** Active authorization-text version data returned to the frontend for display at consent time. Returned by GET /authorization-text/active for the requested (paymentMethodType, authorizationType); also echoed inline in error responses when a stale-version rejection happens, so the consent component can re-render onto the new active version without a full page refresh. */
export interface IActiveAuthorizationTextDto {
    /** Id of the active AuthorizationTextVersion. */
    versionId: number;
    /** Exact text to display to the user. The client must echo this verbatim
back on the consent submission so the server can hash-compare against
its stored hash.
 */
    text: string;

    [key: string]: any;
}

export class ErrorDto implements IErrorDto {
    /** Error message to display to the user */
    errorMessage!: string;
    /** Random number to help correlate the error log with what the user sees.
Prefix "S" is for Server error; "C" is for Client error.
 */
    errorNumber!: string;
    /** Error def identifying the error */
    errorDef!: string;
    /** Error details for troubleshooting/development */
    errorDetails?: string;
    /** Prompt the user with a modal dialog with this message. */
    prompt?: boolean;
    /** For `errorDef = "AuthorizationVersionStale"` rejections only: the new
currently-active authorization text. The consent component re-renders
onto this version inline (deviation #4), allowing the user to re-confirm
without losing other form state. Absent for all other error responses. */
    activeAuthorizationText?: ActiveAuthorizationTextDto;

    [key: string]: any;

    constructor(data?: IErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.errorMessage = _data["errorMessage"];
            this.errorNumber = _data["errorNumber"];
            this.errorDef = _data["errorDef"];
            this.errorDetails = _data["errorDetails"];
            this.prompt = _data["prompt"];
            this.activeAuthorizationText = _data["activeAuthorizationText"] ? ActiveAuthorizationTextDto.fromJS(_data["activeAuthorizationText"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["errorMessage"] = this.errorMessage;
        data["errorNumber"] = this.errorNumber;
        data["errorDef"] = this.errorDef;
        data["errorDetails"] = this.errorDetails;
        data["prompt"] = this.prompt;
        data["activeAuthorizationText"] = this.activeAuthorizationText ? this.activeAuthorizationText.toJSON() : <any>undefined;
        return data;
    }
}

export interface IErrorDto {
    /** Error message to display to the user */
    errorMessage: string;
    /** Random number to help correlate the error log with what the user sees.
Prefix "S" is for Server error; "C" is for Client error.
 */
    errorNumber: string;
    /** Error def identifying the error */
    errorDef: string;
    /** Error details for troubleshooting/development */
    errorDetails?: string;
    /** Prompt the user with a modal dialog with this message. */
    prompt?: boolean;
    /** For `errorDef = "AuthorizationVersionStale"` rejections only: the new
currently-active authorization text. The consent component re-renders
onto this version inline (deviation #4), allowing the user to re-confirm
without losing other form state. Absent for all other error responses. */
    activeAuthorizationText?: ActiveAuthorizationTextDto;

    [key: string]: any;
}

export class InternalApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isInternalApiException = true;

    static isInternalApiException(obj: any): obj is InternalApiException {
        return obj.isInternalApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new InternalApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}